import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { BoxFlex } from '@woovi/ui';

import type { ReactNode } from 'react';

const PaymentActiveRegisterInfo = (): ReactNode => {
  const { t } = useTranslation();

  return (
    <BoxFlex sx={{ justifyContent: 'center' }}>
      <Typography
        variant={'body1'}
        sx={{
          textAlign: 'center',
          fontSize: 18,
        }}
      >
        {t('Enter your details to continue')}
      </Typography>
    </BoxFlex>
  );
};

export default PaymentActiveRegisterInfo;
